export const invertedMessages = {
  'Action will not be applied for access items that belong to the certifier.':
    'ShowSelfCertificationNote.Default.Label',
};
